import CasaMapaLocaleCurrencyTools from "../casamap/chrome/CasaMapaLocaleCurrencyTools";
import { CASAMAPA_ADMIN_PORTAL_I18N_MANIFEST } from "../../constants/casamapaAdminPortalI18n";

export default function CasaMapaAdminPortalLocaleControls({ variant = "inline" }) {
  const manifestI18n = CASAMAPA_ADMIN_PORTAL_I18N_MANIFEST.i18n;
  const isSidebar = variant === "sidebar";
  const isMenu = variant === "menu";

  return (
    <CasaMapaLocaleCurrencyTools
      className={[
        "casamapa-admin-locale-tools",
        isSidebar ? "casamapa-admin-locale-tools--sidebar" : "",
        isMenu ? "casamapa-admin-locale-tools--menu" : "",
      ]
        .filter(Boolean)
        .join(" ")}
      compact={!isSidebar && !isMenu}
      menu={isSidebar || isMenu}
      supportedLocales={manifestI18n.supportedLocales}
      supportedCurrencies={manifestI18n.supportedCurrencies}
    />
  );
}
